export default {
    name: 'calendar_item_with_performance_code',
    definition: {
        created_by_id: '',
        end: '',
        institute_id: '',
        is_editable: '',
        is_deletable: '',
        is_unfulfillable: '',
        is_unfulfilled: '',
        has_recurring_appointments: '',
        location_id: '',
        performance_code_id: '',
        start: '',
        send_confirmation: '',
        send_reminder: '',
        note: '',
        calendar_item_participations: {
            jsonApi: 'hasMany',
            type: 'calendar_item_with_performance_code_participation',
            include: true,
        },
        employees: {
            jsonApi: 'hasMany',
            type: 'employee',
        },
        location: {
            jsonApi: 'hasOne',
            type: 'location',
        },
        location_rooms: {
            jsonApi: 'hasMany',
            type: 'location_room',
        },
        location_devices: {
            jsonApi: 'hasMany',
            type: 'location_device',
        },
        performance_code: {
            jsonApi: 'hasOne',
            type: 'performance_code',
        },
        performance_code_alias: {
            jsonApi: 'hasOne',
            type: 'performance_code_alias',
        },
    },
    options: {
        collectionPath: 'calendar_items',
    },
};
